import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';
import { PluckingAndSundryLabourChecklistObject } from '../PluckingAndSundryLabourChecklistReportSchema';
import { validateProperty } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const screenCode = 'PLUCKINGANDSUNDRYLABOURCHECKLISTREPORT';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function PluckingAndSundryLabourChecklist(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();
    const [errors, setErrors] = useState({});
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1070, 700]
    };
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [collectionCategoryReport, setcollectionCategoryReport] = useState([]);
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            searchDate: "",
            empType: "0"

        }
    );

    const [contentRowNames, setContentRowNames] = useState(["employeeID", "epfNo",
        "firstName", "convertedEmployeeBiometricData", "nic", 'designationName', "startTime", "endTime", "fieldName"])
    const [isTableHide, setIsTableHide] = useState(true);
    const [excelData, setExcelData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        date: "",
        empType: ""
    })
    const initialContentRowNames = ["", "employeeID", "epfNo", "firstName", "convertedEmployeeBiometricData", "nic", 'designationName',
        "collectionPointName", "startTime", "endTime", "fieldName"];
    const initialCsvHeaders = [
        { label: "Emp ID", value: "employeeID" },
        { label: "FirstName", value: "firstName" },
        { label: "Designation", value: "designationName" },
        { label: "Division", value: "division" },
        { label: "NIC", value: "nic" },
        { label: "In Date & Time", value: "startTime" },
        { label: "Out Date & Time", value: "endTime" }
    ];
    const [csvHeaders, setCsvHeaders] = useState([]);


    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown()
        )
    }, [searchForm.estateID]);

    useEffect(() => {
        setIsTableHide(false);
    }, [collectionCategoryReport]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPLUCKINGANDSUNDRYLABOURCHECKLISTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: "0",
            sessionID: "0",
            searchDate: target.value
        });
    }

    function handleEmpTypeChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            empType: target.value,
            sessionID: "0"
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, PluckingAndSundryLabourChecklistObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        setcollectionCategoryReport([]);
        setIsTableHide(true);
        getSelectedDropdownValuesForReport(searchForm);
        var reportData = await services.GetPluckingAndSundryLabourChecklistReportData(searchForm);

        let rowNames = initialContentRowNames;
        let headerNames = initialCsvHeaders;

        setContentRowNames(rowNames);
        setCsvHeaders(headerNames);

        if (reportData.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }
        setcollectionCategoryReport(reportData);
        setDataForExcelData(reportData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Plucking And Sundry Attendance',
            fileName: 'Plucking And Sundry Labour Attendance Report',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(collectionCategoryReport)
        var newRow1 = {
            employeeID: "Estate : " + selectedSearchValues.estate,
            firstName: "Division : " + selectedSearchValues.division,
        }
        var newRow2 = {
            employeeID: "Date : " + selectedSearchValues.date,
            firstName: selectedSearchValues.empType == 0 ? "Employee Type: All Employee Type" : selectedSearchValues.empType == 2 ? "Employee Type: Labour" : "Employee Type: Sundry"

        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(initialCsvHeaders, copyOfCsv, settings, true)
    }

    function setDataForExcelData(data) {
        var res = [];
        var dataCopy = _.cloneDeep(data);
        dataCopy.forEach(x => {

            var a = _.cloneDeep(x);

            delete a[0].collectionPointID;
            delete a[0].fieldID;
            delete a[0].convertedEmployeeBiometricData;
            delete a[0].pluckingCollectionID;

            res.push(...a);

        });
        setExcelData(dataCopy);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            date: searchForm.searchDate,
            empType: searchForm.empType
        })
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Plucking And Sundry Labour Attendance Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => trackPromise(handleSearch(e))}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate</InputLabel>
                                        <Select fullWidth
                                            id="estateID"
                                            name="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.estateID}
                                            onChange={(e) => handleEstateChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Division *</InputLabel>
                                        <Select fullWidth
                                            id="divisionID"
                                            name="divisionID"
                                            value={searchForm.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--All Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="empType">Job Type</InputLabel>
                                        <Select fullWidth
                                            id="empType"
                                            name="empType"
                                            value={searchForm.empType}
                                            onChange={(e) => handleEmpTypeChange(e.target)}>
                                            <MenuItem value="0">Select Job Type</MenuItem>
                                            <MenuItem value="2">Plucker</MenuItem>
                                            <MenuItem value="3">Sundry</MenuItem>
                                        </Select>
                                        {errors["empType"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["empType"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={(e) => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            <div hidden={collectionCategoryReport == 0}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>EPF No</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Picture</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Job Type</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>NIC</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>In Date & Time</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Out Date & Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {collectionCategoryReport.slice(page * limit, page * limit + limit).map((row, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row" align="center"> {row.epfNo}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.convertedEmployeeBiometricData && (<img src={row.convertedEmployeeBiometricData} width="75" height="75"></img>)}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.firstName}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.designationName}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.division}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.nic}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {moment(row.startTime).format('YYYY-MMM-DD h:mm:ss A')}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {moment(row.endTime).format('YYYY-MMM-DD h:mm:ss A')}</TableCell>
                                                </TableRow>
                                            )
                                            )}

                                        </TableBody>
                                        <TableHead>
                                        </TableHead>

                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={collectionCategoryReport.length}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handleLimitChange}
                                        page={page}
                                        rowsPerPage={limit}
                                        rowsPerPageOptions={[5, 10, 25]}
                                    />
                                </TableContainer>
                                <div className="pt-2">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Plucking and Sundry Attendence Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={collectionCategoryReport}
                                        rowNames={contentRowNames} searchData={selectedSearchValues} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

